import { render, staticRenderFns } from "./CommunityItemTalk.vue?vue&type=template&id=3d3057da&scoped=true"
import script from "./CommunityItemTalk.vue?vue&type=script&lang=js"
export * from "./CommunityItemTalk.vue?vue&type=script&lang=js"
import style0 from "./CommunityItemTalk.vue?vue&type=style&index=0&id=3d3057da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3057da",
  null
  
)

export default component.exports